import React from 'react';
import Input from '../../../components/ui/Input';
import { formatCurrencyInput, parseCurrencyBR } from '../../../utils/currencyFormatter';

const RevenueSection = ({ formData, errors, onChange }) => {
  const handleCurrencyInputChange = (field, rawValue) => {
    const formatted = formatCurrencyInput(rawValue);
    onChange(field, formatted);
  };

  const valorAFaturar = formData?.totalObra && formData?.valorJaFaturado
    ? (parseCurrencyBR(formData?.totalObra) - parseCurrencyBR(formData?.valorJaFaturado))?.toFixed(2)
    : parseCurrencyBR(formData?.totalObra)?.toFixed(2);

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <h3 className="text-xl font-bold text-foreground mb-6">Quanto o cliente paga</h3>
      <div className="space-y-5">
        <Input
          label="Valor Total da Obra"
          type="text"
          inputMode="decimal"
          placeholder="0,00"
          value={formData?.totalObra}
          onChange={(e) => handleCurrencyInputChange('totalObra', e?.target?.value)}
          error={errors?.totalObra}
          required
          description="Receita total do contrato"
          className="text-base"
        />
        
        <Input
          label="Valor Já Faturado"
          type="text"
          inputMode="decimal"
          placeholder="0,00"
          value={formData?.valorJaFaturado}
          onChange={(e) => handleCurrencyInputChange('valorJaFaturado', e?.target?.value)}
          error={errors?.valorJaFaturado}
          description="Valor já recebido (opcional)"
          className="text-base"
        />
        
        <div className="p-4 bg-muted rounded-lg border border-border">
          <p className="text-sm font-semibold text-muted-foreground mb-2">Valor a Faturar</p>
          <p className="text-3xl font-bold text-foreground tracking-tight">R$ {parseFloat(valorAFaturar)?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
        </div>
        
        <Input
          label="Nome da Obra (Opcional)"
          type="text"
          placeholder="Ex: Residência Silva"
          value={formData?.nomeObra}
          onChange={(e) => onChange('nomeObra', e?.target?.value)}
          description="Identificação da obra"
          className="text-base"
        />
      </div>
    </div>
  );
};

export default RevenueSection;